module.exports = __webpack_public_path__ + "static/media/logo.cbded903.svg";